
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-indication',
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading-indication.component.html',
  styleUrl: './loading-indication.component.scss',
  standalone: true,
})
export class LoadingIndicationComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() displayText = '';
}
